import { useCallback } from 'react';
import PropTypes from 'prop-types';
import Grid from '@mui/material/Grid';
import Paper from '@mui/material/Paper';
import Stack from '@mui/material/Stack';
import { addDays, format } from 'date-fns';
import { isNilOrEmpty } from 'ramda-extension';
import { useDispatch } from 'react-redux';

import { getLabelMessage } from '@gef-ui/localization/messages';

import { ComponentLoader } from 'components';
import OutputTextField from 'components/atoms/GefMui/OutputTextField';
import SectionHeader from 'components/atoms/GefMui/SectionHeader';
import { urls } from 'features/common/fetch/constants';
import { fetchLeadDetails } from 'features/views/leadDetail/actions';
import { equalOrThreeDashes } from 'utils';
import { fromIsoDate } from 'utils/apiDateTime';

export const LeadInfo = ({ lead }) => {
	const showFinishTypeIdSetDate = lead.statusId !== 3 && !isNilOrEmpty(lead.finishTypeId);
	const finishTypeSetDate = lead?.deadlineDate
		? format(addDays(new Date(lead?.deadlineDate), lead.taskTypeTtl), 'dd/MM/yyyy')
		: equalOrThreeDashes();

	const dispatch = useDispatch();

	const handleReloadLeadDetail = useCallback(() => {
		dispatch(fetchLeadDetails(lead?.id));
	}, [dispatch, lead?.id]);

	return (
		<Paper sx={{ p: 3, borderRadius: 2 }}>
			<ComponentLoader fetchStorePath={urls.leadDetail} onReload={handleReloadLeadDetail}>
				<Stack spacing={2}>
					<SectionHeader text={getLabelMessage('leadDetail:leadInfo')} />
					<Grid container>
						<Grid size={12}>
							<Grid container spacing={2}>
								<Grid size={4}>
									<OutputTextField
										size="small"
										id="leadNotificationDate"
										label={getLabelMessage('leadDetail:leadNotificationDate')}
										fullWidth
										value={fromIsoDate(lead?.notificationDate)}
										slotProps={{
											inputLabel: {
												shrink: !!lead?.notificationDate,
											},
										}}
									/>
								</Grid>
								<Grid size={4}>
									<OutputTextField
										size="small"
										id="leadDeadlineDate"
										label={getLabelMessage('leadDetail:leadDeadlineDate')}
										fullWidth
										value={fromIsoDate(lead?.deadlineDate)}
										slotProps={{
											inputLabel: {
												shrink: !!lead?.deadlineDate,
											},
										}}
									/>
								</Grid>
								<Grid size={4}>
									<OutputTextField
										size="small"
										id="leadSubtype"
										label={getLabelMessage('leadDetail:leadSubtype')}
										fullWidth
										value={lead?.taskSubtypeName}
										slotProps={{
											inputLabel: {
												shrink: !!lead?.taskSubtypeName,
											},
										}}
									/>
								</Grid>
								{showFinishTypeIdSetDate && (
									<Grid size={4}>
										<OutputTextField
											size="small"
											id="finishTypeSetDate"
											label={getLabelMessage('leadDetail:finishTypeSetDate')}
											fullWidth
											value={finishTypeSetDate}
											slotProps={{
												inputLabel: {
													shrink: !!finishTypeSetDate,
												},
											}}
										/>
									</Grid>
								)}
							</Grid>
						</Grid>
					</Grid>
				</Stack>
			</ComponentLoader>
		</Paper>
	);
};

LeadInfo.propTypes = {
	lead: PropTypes.object,
};

export default LeadInfo;
